import Basic from './Basic.jsx';
import Confirmation from './Confirmation.jsx';
import BasicModal from './BasicModal.jsx';
import CustomModal from './CustomModal.jsx';
import ConfirmDialog from './ConfirmDialog.jsx';
import ModalCommentBody from './CommentModalBody.jsx';

const ModalExports = {
  Basic,
  Confirmation,
  BasicModal,
  CustomModal,
  ConfirmDialog,
  ModalCommentBody,
};
export default ModalExports;
